import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import LearnerView from './Components/LearnerView';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms } from '../redux/reducers/userProgramsFull';

import { selectedContent, getAllThinkTools, getAllThinkToolsAndJournals, selectedContentId, getUserPrograms } from '../redux/selectors';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { modulesListRequest } from '../redux/reducers/modulesList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Learner = ({ view }) => <LearnerView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  programs: getUserPrograms(state),
  selectedContentItem: selectedContent(state),
  selectedContentId: selectedContentId(state),
  getAllThinkToolsAndJournals: getAllThinkToolsAndJournals(state),
  content: state.contentListReducer.content
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  getUserProgramsFullRequest: token => dispatch(getUserProgramsFullRequest(token)),
  connectedUsersRequest: () => dispatch(connectedUsersRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        toggleRefererPage,
        selectedContentId,
        getAllThinkToolsAndJournals
      } = this.props;

    
      
     
    },
    componentWillReceiveProps(nextProps) {
      const { loginReducer, getClientBackGroundRequest, view } = nextProps;

     
    },
  }),
)(Learner);

Learner.propTypes = {
  view: PropTypes.instanceOf(Object),
};
